module.exports = __webpack_public_path__ + "img/qlc.18c58411.jpg";